// extracted by mini-css-extract-plugin
export default {"board":"IllustrationBoard_board__OMpcf","boardPart":"IllustrationBoard_boardPart__iALWK","colorPicker":"IllustrationBoard_colorPicker__8htTJ"};